import { CognitoLoginView } from './CognitoLoginView'
import { SingleSignOn } from './SingleSignOn'
import { useLoginType } from './useLoginType'

export const LoginView = () => {
  const { hasCognitoLogin } = useLoginType()
  return hasCognitoLogin ? <CognitoLoginView /> : <SingleSignOn />
}
